import { Events } from '@shared/Events';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import './Drawer.scss';

let el: HTMLDivElement = null;

$(init);

function init() {
    if (el) return;
    el = document.createElement('div');
    el.id = 'drawer';
    el.classList.add('off');
    try {
        document.body.appendChild(el);
    } catch {}
}

function open(width = 350): HTMLElement {
    el.classList.remove('off');
    el.style.width = width + 'px';
    document.querySelector('.js-sidebar')?.classList.add('off');

    return el;
}

function close(): HTMLElement {
    ReactUtils.safeUnmountComponentAtNode(el);
    el.classList.add('off');
    document.querySelector('.js-sidebar')?.classList.remove('off');
    Events.trigger('drawer-close.editor');
    return el;
}

export const Drawer = {
    open,
    close,
};
